import { apiRequest } from '../../services/apiClient';
import { QuoteInquirySchema } from './quoteInquirySchema';

// INQUIRY: 견적문의 메뉴 / ORDER: 주문하기 메뉴 (관리자 화면에서 메뉴가 나뉜다)
export type RequestType = 'INQUIRY' | 'ORDER';

export interface SubmitQuoteInquiryResult {
  id: string;
  orderNo: string;
}

export function submitQuoteInquiry(
  values: QuoteInquirySchema,
  files: File[],
  token?: string,
  requestType: RequestType = 'INQUIRY',
): Promise<SubmitQuoteInquiryResult> {
  const formData = new FormData();
  formData.append('requestType', requestType);
  if (requestType === 'ORDER' && values.designType) formData.append('designType', values.designType);
  formData.append('shippingMethod', values.shippingMethod);
  formData.append('title', values.title);
  formData.append('company', values.company);
  formData.append('name', values.name);
  if (!token && values.password) formData.append('password', values.password);
  formData.append('email', values.email);
  formData.append('phone', `${values.phone1}${values.phone2}${values.phone3}`);
  formData.append('shape', values.shape);
  formData.append('quantity', String(values.quantity));
  formData.append('boxSize', values.boxSize);
  if (values.contentSize) formData.append('contentSize', values.contentSize);
  if (values.contentType) formData.append('contentType', values.contentType);
  if (values.deadline) formData.append('deadline', values.deadline);
  if (values.budget) formData.append('budget', values.budget);
  if (values.print) formData.append('print', values.print);
  if (values.route) formData.append('route', values.route);
  formData.append('content', values.content);
  if (values.reference) formData.append('reference', values.reference);
  files.forEach((file) => formData.append('attachments', file));

  return apiRequest<SubmitQuoteInquiryResult>('/api/quote-inquiries', {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    body: formData,
  });
}
